//* 组件属性
import type { DiagramsOption, DiagramsHeadOption } from "../index";

//* 对照表
export const contrast = ["", "asc", "desc"];

//* 获取表头的最大行数
export const get_row_number = (data: DiagramsOption[]): number => {
    //* 数据初始化
    const result = { number: 0 };
    //* 递归统计最大行数
    data?.forEach((value) => {
        let number = 1;
        if (value.children?.length) {
            number += get_row_number(value.children);
        }

        if (number > result.number) {
            result.number = number;
        }
    });

    return result.number;
};

//* 获取表格列偏移
export const get_row_offset = (key: string, option: DiagramsOption[]) => {
    //* 数据初始化
    let result = 0;
    //* 循环统计数据
    for (let i = 0; i < option.length; i++) {
        if (option[i].key == key) return result;
        else {
            result += option[i].width || 200;
        }
    }

    return result;
};

//* 获取表格配置项
export const get_row_options = (data: DiagramsOption[]) => {
    //* 数据初始化
    const result: DiagramsOption[] = [];
    //* 循环展开数据
    data.forEach((value) => {
        if (value.children && value.children.length) {
            result.push(...get_row_options(value.children));
        } else {
            result.push(value);
        }
    });

    //* 返回
    return result;
};

//* 获取表格配置项
export const get_row_header_options = (data: DiagramsOption[], number: number, deep: number) => {
    //* 数据初始化
    const rows: DiagramsHeadOption[] = [];
    const result: DiagramsHeadOption[][] = [];
    const children: DiagramsOption[] = [];

    //* 循环展开数据
    data.forEach((value) => {
        if (value.children && value.children.length) {
            children.push(...value.children);
            rows.push({ ...value, rowspan: 1, colspan: value.children.length });
        } else {
            rows.push({ ...value, rowspan: number - deep, colspan: 1 });
        }
    });

    //* 数据更新
    result.push(rows);

    //* 检测是否退出递归
    if (number == deep - 1 || children.length <= 0) {
        return result;
    } else {
        //* 数据更新
        result.push(...get_row_header_options(children, number, ++deep));
        //* 返回
        return result;
    }
};

//* 获取排序结果
export const get_sort_result = (index: number) => {
    if (index < 0) return contrast.slice(index)[0];
    else if (index >= contrast.length) return contrast[0];
    else {
        return contrast[index];
    }
};

//* 获取key对应的配置
export const get_key_option = (key: string, data: DiagramsHeadOption[][]) => {
    for (let colspan = 0; colspan < data.length; colspan++) {
        for (let row = 0; row < data[colspan].length; row++) {
            if (data[colspan][row].key == key) {
                return data[colspan][row];
            }
        }
    }

    return;
};
